import { __assign } from "tslib";
import { CustomInputType } from "./customInput.model";
import { getSanitizedHtmlText } from "../../utils/serviceUtils";
var customInputValues = Object.values(CustomInputType);
var checkEmptySpaces = function (str) {
    var text = str.replace(/<[^>]+>/g, "");
    return /^(?:&nbsp;)+$/.test(text);
};
export function checkValueExistence(value, isArray) {
    if (!isArray) {
        return typeof value !== "undefined" && value !== null && (typeof value !== "string" || value.length > 0);
    }
    else {
        return typeof value === "object" && !!(value === null || value === void 0 ? void 0 : value.hasOwnProperty("length")) && Object.entries(value).length > 0;
    }
}
export function checkInputValidity(inputData, options) {
    var markAsDirty = (options || {}).markAsDirty;
    var validations = inputData.validations, value = inputData.value;
    var error = "";
    var finalValue = value;
    var isAnActualNumber = false;
    if (validations) {
        var required = validations.required, isInteger = validations.isInteger, isArray = validations.isArray, isNumber = validations.isNumber, max = validations.max, maxLength = validations.maxLength, min = validations.min, minLength = validations.minLength;
        var valueExists = checkValueExistence(value, !!isArray);
        if (!valueExists) {
            if (required) {
                error = "This field is required. ";
            }
        }
        else {
            if (isNumber) {
                finalValue = parseFloat("".concat(value));
                isAnActualNumber = true;
                if (isNaN(finalValue)) {
                    error = "This field's value must be a number. ";
                }
            }
            else if (isInteger) {
                finalValue = parseFloat("".concat(value));
                var valueData = "".concat(finalValue).split(".");
                isAnActualNumber = true;
                if (isNaN(finalValue) || valueData.length === 2) {
                    error = "This field's value must be an integer. ";
                }
            }
            else {
                if (typeof maxLength !== "undefined") {
                    finalValue = "".concat(value);
                    if (finalValue.length > maxLength) {
                        error = "This field's value cannot exceed ".concat(maxLength, " characters. ");
                    }
                }
                if (!error.length && typeof minLength !== "undefined") {
                    finalValue = "".concat(value);
                    if (finalValue.length < minLength) {
                        error = "This field's value cannot be less than ".concat(minLength, " characters. ");
                    }
                }
            }
            if (isAnActualNumber) {
                if (typeof max !== "undefined") {
                    if (typeof finalValue !== "number") {
                        finalValue = parseFloat("".concat(finalValue));
                    }
                    isAnActualNumber = true;
                    if (finalValue > max) {
                        error = "This field's value cannot exceed ".concat(max, ". ");
                    }
                }
                if (!error.length && typeof min !== "undefined") {
                    if (typeof finalValue !== "number") {
                        finalValue = parseFloat("".concat(finalValue));
                    }
                    isAnActualNumber = true;
                    if (finalValue < min) {
                        error = "This field's value cannot be less than ".concat(min, ". ");
                    }
                }
            }
        }
    }
    return __assign(__assign({}, inputData), { error: error.length ? error : null, pristine: markAsDirty === true ? false : inputData.pristine, value: (isAnActualNumber && isNaN(finalValue) ? "" : finalValue) });
}
export function isCustomInputObject(inputData) {
    return (inputData &&
        typeof inputData.error !== "undefined" &&
        typeof inputData.pristine !== "undefined" &&
        typeof inputData.statePath !== "undefined" &&
        customInputValues.includes(inputData.type));
}
export function validateInput(value, options) {
    var dispatch = options.dispatch, setStateValue = options.setStateValue, inputData = options.inputData, markAsDirty = options.markAsDirty, validateForm = options.validateForm;
    var newInputData = checkInputValidity(__assign(__assign({}, inputData), { value: value }), {
        markAsDirty: markAsDirty
    });
    var type = inputData.type;
    var finalInputValue = value;
    if (type === CustomInputType.Number) {
        if (typeof value === "string") {
            finalInputValue = parseFloat(value);
        }
    }
    else if (type === CustomInputType.Checkbox) {
        if (typeof value === "string") {
            finalInputValue = value === "true" || value === "checked";
        }
    }
    else if (type === CustomInputType.Editor) {
        if (checkEmptySpaces(value)) {
            var emptyText = getSanitizedHtmlText(value);
            if (emptyText) {
                finalInputValue = emptyText.trim();
            }
        }
    }
    else if (typeof value === "string") {
        if (value === "true") {
            finalInputValue = true;
        }
        else if (value === "false") {
            finalInputValue = false;
        }
    }
    dispatch(setStateValue({
        key: "".concat(inputData.statePath, ".value"),
        value: finalInputValue
    }));
    dispatch(setStateValue({
        key: "".concat(inputData.statePath, ".error"),
        value: newInputData.error
    }));
    dispatch(setStateValue({ key: "".concat(inputData.statePath, ".pristine"), value: newInputData.pristine }));
    if (validateForm && inputData.formStatePath) {
        dispatch(validateForm({ formStatePath: inputData.formStatePath, markInputsAsDirty: markAsDirty }));
    }
}
//# sourceMappingURL=customInput.utils.js.map